/* ============================================================
   HBX Theme — Main JS
   ============================================================ */

(function() {
  'use strict';

  // ── NAV SCROLL STATE ──────────────────────────────────────
  // Handled inline in header.liquid for immediate execution

  // ── PRODUCT IMAGE ZOOM ────────────────────────────────────
  function initImageZoom() {
    var mainImg = document.querySelector('.hbx-pd__gallery-main img');
    if (!mainImg) return;

    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', function() {
      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.9);display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
      var img = document.createElement('img');
      img.src = mainImg.src;
      img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:8px;';
      overlay.appendChild(img);
      overlay.addEventListener('click', function() { document.body.removeChild(overlay); });
      document.body.appendChild(overlay);
    });
  }

  // ── SCROLL ANIMATIONS ─────────────────────────────────────
  function initScrollAnimations() {
    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    var animEls = document.querySelectorAll('.hbx-product-card, .hbx-benefit, .hbx-pillar, .hbx-value-card, .hbx-stat-card');
    animEls.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .45s ease ' + (i % 4 * 0.07) + 's, transform .45s ease ' + (i % 4 * 0.07) + 's';
      observer.observe(el);
    });
  }

  // ── STICKY FILTER BAR ─────────────────────────────────────
  function initStickyFilter() {
    var filterBar = document.querySelector('.hbx-collection-bar');
    if (!filterBar) return;

    // Ensure filter pills scroll horizontally without showing scrollbar
    var filtersEl = filterBar.querySelector('.hbx-filters');
    if (filtersEl) {
      filtersEl.style.scrollbarWidth = 'none';
      filtersEl.style.msOverflowStyle = 'none';
    }
  }

  // ── NOTIFICATION TOAST ───────────────────────────────────
  window.HBX = window.HBX || {};
  window.HBX.toast = function(message, type) {
    var toast = document.createElement('div');
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'right:24px',
      'z-index:9999',
      'background:' + (type === 'error' ? '#c0392b' : '#1A4731'),
      'color:#fff',
      'padding:14px 20px',
      'border-radius:10px',
      'font-size:.88rem',
      'font-weight:600',
      'font-family:"ABC Favorit",sans-serif',
      'box-shadow:0 8px 24px rgba(0,0,0,.4)',
      'animation:hbx-fadeUp .3s ease',
      'max-width:320px',
      'line-height:1.5'
    ].join(';');
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity .3s';
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, 3500);
  };

  // ── INIT ─────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initImageZoom();
    initScrollAnimations();
    initStickyFilter();
  });

})();
